import { useEffect } from 'react';
import { setIsAdvancedSpacingModelOpen } from '../../../../grid/reduxStore/blockStyleSettingsSlice';
import { useAppDispatch } from '../../../../grid/reduxStore/Store';

export function useCloseAdvancedSpacingOnDeselect(selectedBlockId: string | null | undefined) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!selectedBlockId) {
      dispatch(setIsAdvancedSpacingModelOpen(false));
    }
  }, [selectedBlockId, dispatch]);
}
